module.exports = __webpack_public_path__ + "static/media/guide-icon.2d3a5abf.png";